/*
 * @Descripttion:
 * @Author: 李子和
 * @Date: 2019-12-04 17:35:31
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/index.js'
import ElementUI from 'element-ui'
import '../theme/index.css'
import './assets/icon/iconfont.css'
import 'font-awesome/css/font-awesome.css'
import './assets/style.css'
import tagCloud from '../src/components/extract/tagCloud'
import 'animate.css'
import md5 from 'js-md5'
import '@/mocks/index.js'
import './permission.js'
import '@/style/table.scss'
import '@/style/init-ui.scss'
import Print from 'vue-print-nb'
Vue.use(Print)
Vue.use(tagCloud)
Vue.use(ElementUI)
Vue.prototype.$md5 = md5
export const event = new Vue()

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js